export const SERVER_AUTH_BASE_PATH = '/scan/auth';
